import React from 'react';
import Teams from '../components/Teams';
import './Page.css';

function TeamsPage() {
  return (
    <div className="page-wrapper">
      <Teams />
    </div>
  );
}

export default TeamsPage;
